module.exports = __webpack_public_path__ + "maxelectro.png?79418399a33560061cbb1cdccd999006";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maxelectro.png
// module id = 979
// module chunks = 2